import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { FormControl } from '@angular/forms';
import { MatSort, MatTableDataSource } from '@angular/material';
import { MatDialog } from '@angular/material/dialog';
import { ChequeClearPopupComponent } from '../cheque-clear-popup/cheque-clear-popup.component';

@Component({
  selector: 'app-cheque-approval',
  templateUrl: './cheque-approval.component.html',
  styleUrls: ['./cheque-approval.component.scss']
})
export class ChequeApprovalComponent implements OnInit {
  nameFilter = new FormControl('');
  filterValues = {
    id: '',
    bank_name: '',
    account_holder_name: '',
    account_number: '',
    cheque_number: ''
  };
  dataSource = new MatTableDataSource();
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  displayedColumns: string[] = ['id','booth_name','booth_code', 'acc_holder_name', 'cheque_number', 'date_of_issue', 'is_cleared'];
  agent_id: any;
  title= null;

  constructor(private global: GlobalService, private http: HttpService, private dialog: MatDialog) {
    // this.global.set_master_page_title = 'Cheque Approvals';
    this.title = this.global._active_display_name;

    this.getChequeApprovalStatus();
   }

  getChequeApprovalStatus() {
    this.http.getChequeStatusLog().subscribe((data: [])=> {
      console.log(data);
      this.dataSource.sort = this.sort;
      this.dataSource.data = data;
    },(error)=>{
      console.log(error);
    });
  }

  openClearcheque(element) {
    console.log()
    element['agent_id'] = element['transacted_by']
    const dialogRef = this.dialog.open(ChequeClearPopupComponent, {
      height: '600px',
      width: '600px',
      data: element
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getChequeApprovalStatus();
    })

  }

  ngOnInit() {
  }

}
